angular.module('tf.directives')


    .directive('ssoChecker',  function($http) {
        return {
            restrict        :'A',
            scope           : {
                ssoChecker  : '='
            },
            link: function (scope, element, attrs) {

                function Cache(options){
                    this.options = options || {};
                    this.options.timeout = this.options.timeout || 10000;
                    this.cache = {};
                    this.timeouts = {};
                }
                Cache.prototype._setExpiration = function(key){
                    var self = this;
                    clearTimeout(self.timeouts[key]);
                    this.timeouts[key] = setTimeout(function(){
                        delete self.cache[key];
                        delete self.timeouts[key];
                    }, self.options.timeout);
                };
                Cache.prototype.store = function(key, value){
                    this.cache[key] = value;
                    this._setExpiration(key);
                };
                Cache.prototype.load = function(key){
                    var value = this.cache[key];
                    if(value !== undefined){
                        this._setExpiration(key);
                    }
                    return value;
                };

                var CACHE = new Cache({timeout : 60000});


                var emailRegex = /^[\S@]+@[\S@]+\.[\S@]+$/;

                function validateEmail(email){
                    return emailRegex.test(email);
                }

                function debounce(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var context = this, args = arguments;
                        var later = function() {
                            timeout = null;
                            if (!immediate) func.apply(context, args);
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) func.apply(context, args);
                    };
                }

                function makeRequest(){
                    var email = element[0].value;
                    $http.get('/sso_state?email=' + email).then(function (res) {
                        CACHE.store(email ,res.data.require_sso);
                        scope.ssoChecker = res.data.require_sso;
                        // console.log("Request:", email, scope.ssoChecker);
                    });
                }

                var debounceRequest = debounce(makeRequest, 500);

                function onChange(){
                    var email = element[0].value;
                    if (validateEmail(email)) {
                        if(CACHE.load(email) !== undefined){
                            scope.ssoChecker = CACHE.load(email);
                            // console.log("Cache:", email, scope.ssoChecker);
                            scope.$apply();
                        } else {
                            debounceRequest();
                        }
                    } else {
                        scope.ssoChecker = false;
                        scope.$apply();
                    }
                }

                setTimeout(function(){
                    onChange();
                },100);

                element.on('input', onChange);

            }
        };
    });

